<template>
    <div>
        <div>
            Guidance {{guidance.name}} : {{guidance.Number}} -
        </div>
        <md-button @click="addWorkPoint()" class="md-raised md-primary">Add Work Point</md-button>
        <div v-for="(workPoint,index) in workPoints" :key="'work-point-'+index">
            <md-card>
                <md-card-content>
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100">
                            <label><b>Workplace/Work Point</b></label>
                            <div v-if="editableWorkPoint === 'workPoint'+workPoint.id">
                                <multiselect v-model="workPoint.workplace"
                                             deselect-label="Can't remove this workplace"
                                             track-by="id"
                                             :id="index"
                                             label="name"
                                             placeholder="Select Workplace"
                                             :options="allWorkplaces"
                                             :searchable="true"
                                             :allow-empty="false"
                                             @select="updateWorkPoint">
                                </multiselect>
                            </div>
                            <md-field v-else>
                                <h4 @click="setEditableWorkPoint(workPoint)">
                                    {{workPoint.workplace.name?workPoint.workplace.name:"Select Workplace"}}
                                </h4>
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100">
                            <label><b>Vessel (if any)</b></label>
                            <div v-if="editableWorkPoint === 'vessel'+workPoint.id">
                                <multiselect v-model="workPoint.vessel"
                                             deselect-label="Can't remove this workplace"
                                             track-by="id"
                                             :id="index"
                                             label="name"
                                             placeholder="Select vessel"
                                             :options="vessels"
                                             :searchable="true"
                                             :close-on-select="true"
                                             @select="updateWorkPointVessel">
                                </multiselect>
                            </div>
                            <md-field v-else>
                                <h4 @click="setEditableWorkPoint(workPoint,'vessel')">
                                    {{workPoint.vessel?workPoint.vessel.name:"No Vessel"}}
                                </h4>
                            </md-field>
                        </div>
                    </div>
                    <h4>Activity List</h4>
                    <md-table table-responsive w-10>
                        <md-table-row>
                            <md-table-head md-numeric>SN</md-table-head>
                            <md-table-head class="cell-50">Activity</md-table-head>
                            <md-table-head class="cell-10" md-numeric>Long Shift</md-table-head>
                            <md-table-head class="cell-10" md-numeric>First</md-table-head>
                            <md-table-head class="cell-10" md-numeric>Second</md-table-head>
                            <md-table-head class="cell-10" md-numeric>Third</md-table-head>
                            <md-table-head></md-table-head>
                        </md-table-row>
                        <template v-for="(activity,ind) in workPoint.activities">
                            <md-table-row
                                    :key="'activity'+ind+''+index">
                                <md-table-cell md-numeric>
                                    <i @click="toggleExceptions(index,ind)"
                                       class="material-icons">{{ exceptionIds.includes(activity.id) ?
                                        'keyboard_arrow_down' :'keyboard_arrow_right' }}</i>
                                    {{ind+1}}
                                </md-table-cell>
                                <md-table-cell>
                                    <div v-if="editableIndex !== 'activity'+activity.id">
                                        <h4 @click="setEditable(activity)">
                                            {{activity.activity?activity.activity.name:"select activity"}}
                                        </h4>
                                    </div>
                                    <div v-else>
                                        <md-field>
                                            <!--                                            <div class="your_custom_class">-->
                                            <multiselect
                                                    class="your_custom_class"
                                                    v-model="activity.activity"
                                                    deselect-label="Can't remove this value"
                                                    track-by="name"
                                                    label="name"
                                                    :id="index+':'+ind"
                                                    placeholder="Select activity"
                                                    :options="activities"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="checkActivity">
                                            </multiselect>
                                            <!--                                            </div>-->
                                        </md-field>
                                        <validation-error :errors="activity.errors?activity.errors.activity_id:[]"/>
                                    </div>
                                </md-table-cell>
                                <md-table-cell class="guidance-shift">
                                    <md-field>
                                        <md-input v-model="activity.office_shift" type="number"
                                                  class="md-numeric-lg"
                                                  @change="updateActivity(index,ind)"
                                                  @focus="$event.target.select()"
                                        ></md-input>
                                        <md-checkbox v-if="activity.office_shift>0"
                                                     :class="activity.office_shift_type==='Provision'?'md-primary':''"
                                                     v-model="activity.office_shift_type"
                                                     value="Provision"
                                                     @change="updateActivity(index,ind)">Pr
                                        </md-checkbox>
                                    </md-field>
                                    <validation-error :errors="activity.errors?activity.errors.office_shift:[]"/>
                                    <!--                                    {{activity.errors?activity.errors.office_shift:''}}-->
                                </md-table-cell>
                                <md-table-cell>
                                    <md-field>
                                        <md-input v-model="activity.first_shift"
                                                  @change="updateActivity(index,ind)"
                                                  type="number"
                                                  class="md-numeric-lg"
                                                  @focus="$event.target.select()"></md-input>
                                        <md-checkbox v-if="activity.first_shift>0"
                                                     :class="activity.first_shift_type==='Provision'?'md-primary':''"
                                                     v-model="activity.first_shift_type"
                                                     value="Provision"
                                                     @change="updateActivity(index,ind)">Pr
                                        </md-checkbox>
                                    </md-field>
                                    <validation-error :errors="activity.errors?activity.errors.first_shift:[]"/>
                                    <!--                                    {{activity.errors?activity.errors.first_shift:''}}-->

                                </md-table-cell>
                                <md-table-cell>
                                    <md-field>
                                        <md-input v-model="activity.second_shift"
                                                  @change="updateActivity(index,ind)"
                                                  @focus="$event.target.select()"
                                                  type="number"
                                                  min="0"
                                                  class="md-numeric-lg"></md-input>
                                        <md-checkbox
                                                v-if="activity.second_shift>0"
                                                :class="activity.second_shift_type==='Provision'?'md-primary':''"
                                                v-model="activity.second_shift_type"
                                                value="Provision"
                                                @change="updateActivity(index,ind)">Pr
                                        </md-checkbox>
                                    </md-field>
                                    <validation-error :errors="activity.errors?activity.errors.second_shift:[]"/>
                                    <!--                                    {{activity.errors?activity.errors.second_shift:''}}-->
                                </md-table-cell>
                                <md-table-cell>
                                    <md-field class="outer">
                                        <div class="full">

                                            <md-input v-model="activity.third_shift"
                                                      class="md-numeric-lg"
                                                      type="number"
                                                      min="0"
                                                      @focus="$event.target.select()"
                                                      @change="updateActivity(index,ind)"></md-input>
                                        </div>
                                        <md-checkbox
                                                v-if="activity.third_shift>0"
                                                :class="activity.third_shift_type==='Provision'?'md-primary':''"
                                                v-model="activity.third_shift_type"
                                                value="Provision"
                                                @change="updateActivity(index,ind)">Pr
                                        </md-checkbox>
                                    </md-field>
                                    <validation-error :errors="activity.errors?activity.errors.third_shift:[]"/>
                                    <!--                                    {{activity.errors?activity.errors.third_shift:''}}-->

                                </md-table-cell>
                                <md-table-cell>
                                    <div class="md-list">
                                        <md-list-item href="#something" class="dropdown">
                                            <drop-down>
                                                <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
                                                    <i class="material-icons">more_vert</i>
                                                    <p class="hidden-lg hidden-md">Exceptions</p>
                                                </a>
                                                <ul class="dropdown-menu dropdown-menu-right">
                                                    <li><a href="#" @click.prevent="toggleExceptions(index,ind)">
                                                        {{ exceptionIds.includes(activity.id) ? 'Hide' :
                                                        'Show' }}Exceptions</a>
                                                    </li>
                                                    <li><a href="#" @click.prevent="addException('Saturday',index,ind)">Saturday
                                                        Exceptions</a></li>
                                                    <li><a href="#" @click.prevent="addException('Sunday',index,ind)">Sunday
                                                        Exception</a></li>
                                                    <li><a href="#" @click.prevent="addException('Holiday',index,ind)">Holiday
                                                        Exception</a></li>
                                                </ul>
                                            </drop-down>
                                        </md-list-item>
                                    </div>
                                    <md-button class="md-icon-button md-raised md-danger"
                                               @click="removeActivity(index,ind)"
                                               v-if="workPoint.activities.length>1">
                                        <md-icon md>delete</md-icon>
                                    </md-button>
                                    <md-progress-spinner
                                            v-if="savingIds.includes('activity'+index+''+ind)"
                                            class="md-info ml-auto" :md-diameter="30"
                                            md-mode="indeterminate"></md-progress-spinner>
                                    <md-button class="md-icon-button md-raised md-primary"
                                               v-if="failIds.includes('activity'+index+''+ind)"
                                               @click="updateActivity(index,ind)">
                                        <md-icon md>save</md-icon>
                                    </md-button>
                                    <span v-if="activity.saveText === 'show'">Saved</span>
                                </md-table-cell>
                            </md-table-row>
                            <template v-if="exceptionIds.includes(activity.id)">
                                <md-table-row v-for="(exception,exceptionIndex) in activity.exceptions"
                                              class="table-warning"
                                              :key="'exception'+exception.id">
                                    <md-table-cell>{{exceptionIndex+1}}</md-table-cell>
                                    <md-table-cell>
                                        <span>{{exception.day_type}}</span>
                                    </md-table-cell>
                                    <md-table-cell>
                                        <md-field>
                                            <md-input v-model="exception.office_shift"
                                                      type="number"
                                                      min="0"
                                                      class="input-numeric"
                                                      @focus="$event.target.select()"
                                                      @change="updateException(index,ind,exceptionIndex)"
                                            ></md-input>
                                            <md-checkbox v-if="exception.office_shift>0"
                                                         :class="exception.office_shift_type==='Provision'?'md-primary':''"
                                                         v-model="exception.office_shift_type"
                                                         value="Provision"
                                                         @change="updateException(index,ind,exceptionIndex)">Pr
                                            </md-checkbox>
                                        </md-field>
                                    </md-table-cell>
                                    <md-table-cell>
                                        <md-field>
                                            <md-input v-model="exception.first_shift"
                                                      @change="updateException(index,ind,exceptionIndex)"
                                                      @focus="$event.target.select()"
                                                      type="number"
                                                      min="0" class="input-numeric"></md-input>
                                            <md-checkbox v-if="exception.first_shift>0"
                                                         :class="exception.first_shift_type==='Provision'?'md-primary':''"
                                                         v-model="exception.first_shift_type"
                                                         value="Provision"
                                                         @change="updateException(index,ind,exceptionIndex)">Pr
                                            </md-checkbox>
                                        </md-field>

                                    </md-table-cell>
                                    <md-table-cell>
                                        <md-field>
                                            <md-input v-model="exception.second_shift"
                                                      @change="updateException(index,ind,exceptionIndex)"
                                                      @focus="$event.target.select()"
                                                      type="number"
                                                      min="0" class="input-numeric"></md-input>
                                            <md-checkbox
                                                    v-if="exception.second_shift>0"
                                                    :class="exception.second_shift_type==='Provision'?'md-primary':''"
                                                    v-model="exception.second_shift_type"
                                                    value="Provision"
                                                    @change="updateException(index,ind,exceptionIndex)">Pr
                                            </md-checkbox>
                                        </md-field>
                                    </md-table-cell>
                                    <md-table-cell>
                                        <md-field class="outer">
                                            <div class="full">

                                                <md-input v-model="exception.third_shift"
                                                          class="md-numeric-lg"
                                                          type="number"
                                                          min="0"
                                                          @focus="$event.target.select()"
                                                          @change="updateException(index,ind,exceptionIndex)"></md-input>
                                            </div>
                                            <md-checkbox
                                                    v-if="exception.third_shift>0"
                                                    :class="exception.third_shift_type==='Provision'?'md-primary':''"
                                                    v-model="exception.third_shift_type"
                                                    value="Provision"
                                                    @change="updateException(index,ind,exceptionIndex)">Pr
                                            </md-checkbox>
                                        </md-field>

                                    </md-table-cell>
                                    <md-table-cell>

                                        <md-button class="md-icon-button md-raised md-danger"
                                                   @click="removeActivity(index,ind,exceptionIndex)">
                                            <md-icon md>delete</md-icon>
                                        </md-button>
                                        <md-progress-spinner v-if="exception.saving === true"
                                                             class="md-info ml-auto" :md-diameter="30"
                                                             md-mode="indeterminate"></md-progress-spinner>
                                        <md-button class="md-icon-button md-raised md-danger"
                                                   v-if="failIds.includes(exception.id)"
                                                   @click="updateActivity(ind)">
                                            <md-icon md>save</md-icon>
                                        </md-button>
                                        <span v-if="exception.saveText === 'show'">Saved</span>
                                    </md-table-cell>
                                </md-table-row>
                            </template>

                        </template>
                        <md-table-row>
                            <md-table-cell colspan="7">

                                <md-button @click="removeWorkPoint(index)" class="md-danger">
                                    Delete Work Point
                                </md-button>
                                <md-button @click="addActivity(index)" class="md-raised md-primary">Add Activity
                                </md-button>

                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>
            </md-card>
        </div>

        <md-button @click="addWorkPoint()" class="md-raised md-primary">Add Work Point</md-button>
    </div>
</template>

<script>
// import SelectInput from "../../../components/Inputs/SelectInput";
import Multiselect from 'vue-multiselect';
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import Swal from 'sweetalert2';

// import ManageExceptions from "./ManageExceptions";

export default {
    name: 'ManageGuidancePage',
    components: { Multiselect, ValidationError },
    mixins: [formMixin],
    data () {
        return {
            exceptionIds: [],
            saveIds: [],
            savingIds: [],
            failIds: [],
            editableWorkPoint: '',
            editableIndex: '',
            trackBy: 'id',
            buttons: ['button'],
            activities: [],
            allWorkplaces: [],
            vessels: [],
            item: {},
            workPoints: [
                {
                    'workplace': '',
                    'activities': [{
                        activity_id: '',
                        first_shift: 0,
                        second_shift: 0,
                        third_shift: 0,
                        office_shift: 0,
                    }]
                }
            ],
            guidance: {
                type: 'guidances',
                name: null,
                guidance_number: null,
                duration: null,
                start_date: null,
                end_date: null,
                department: {
                    id: null,
                    type: 'departments',
                },
                relationshipNames: ['department'],
            },
        };
    },
    created () {
        this.getActivities();
        this.get();
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                console.log(id);
                await this.$store.dispatch('guidances/get', id);
                this.guidance = this.$store.getters['guidances/guidance'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }

            const id = this.guidance.id;
            this.$store.dispatch('guidances/workplaces', id).then(() => {
                this.workPoints = this.$store.getters['guidances/workplaces'];
                console.log(this.workPoints);
            });
        },
        getActivities () {
            let params = {
                filter: {
                    'hasTariff': 9
                }
            };
            console.log(params);
            this.$store.dispatch('activities/list', params).then(() => {
                this.activities = this.$store.getters['activities/list'];
            });

            this.$store.dispatch('workplaces/list').then(() => {
                this.allWorkplaces = this.$store.getters['workplaces/list'];
            });
            this.$store.dispatch('vessels/list').then(() => {
                this.vessels = this.$store.getters['vessels/list'];
            });
        },
        addWorkPoint () {
            const workplace = {
                'workplace': '',
                'guidance_id': this.guidance.id,
                'activities': []
            };
            this.workPoints.push(workplace);
        },
        addActivity (index) {
            let workPoint = this.workPoints[index];
            console.log(workPoint);
            if (typeof workPoint.workplace_id !== 'undefined') {
                const workplace = this.getEmptyActivity(index, 'Weekday');
                workplace.exceptions = [];
                this.editableIndex = 'activity' + workPoint.activities.length;
                this.workPoints[index].activities.push(workplace);
            } else {
                this.$store.dispatch(
                    'alerts/error',
                    'Oops, please add workplace first!'
                );
            }
        },
        getEmptyActivity (index, day = 'Weekday') {
            let workPoint = this.workPoints[index];
            return {
                guidance_workplace_id: workPoint.id,
                activity: { name: 'Select Activity' },
                day: day,
                activity_id: '',
                workplace_id: workPoint.workplace_id,
                first_shift: 0,
                request_type: 'Open',
                second_shift: 0,
                third_shift: 0,
                office_shift: 0,
                saved: true,
                saveText: false
            };
        },
        setSuccess (workPointIndex, activityIndex, exceptionIndex = null) {
            let indexToRemove;
            this.workPoints[workPointIndex].activities[activityIndex].saved = true;
            this.workPoints[workPointIndex].activities[activityIndex].saveText = true;
            this.workPoints[workPointIndex].activities[activityIndex].saving = false;
            setTimeout(() => this.workPoints[workPointIndex].activities[activityIndex].saveText = 'hide', 1000);
            if (exceptionIndex == null) {
                indexToRemove = this.failIds.findIndex(id => id === 'activity' + workPointIndex + '' + activityIndex);
            } else {
                indexToRemove = this.failIds.findIndex(id => id === 'exception' + workPointIndex + '' + activityIndex + '' + exceptionIndex);
            }
            delete this.workPoints[workPointIndex].activities[activityIndex].errors;
            this.failIds.splice(indexToRemove, 1);
        },
        setError (e, workPointIndex, activityIndex, exceptionIndex = null) {
            if (e.response.data.errors[0]) {
                this.workPoints[workPointIndex].activities[activityIndex].errors = this.apiValidationErrors;
            }
            this.workPoints[workPointIndex].activities[activityIndex].saved = false;
            this.workPoints[workPointIndex].activities[activityIndex].saveText = false;
            this.workPoints[workPointIndex].activities[activityIndex].saving = false;
            let localKey;
            if (exceptionIndex == null) {
                localKey = 'activity' + workPointIndex + '' + activityIndex;
            } else {
                localKey = 'exception' + workPointIndex + '' + activityIndex + '' + exceptionIndex;
            }
            let indexIs = this.findLocalIndex(this.failIds, localKey);

            if (indexIs < 0) {
                this.failIds.push(localKey);
            }
            setTimeout(() => this.workPoints[workPointIndex].activities[activityIndex].saveText = false, 1000);
        },
        findLocalIndex (array, key) {
            return array.findIndex(id => id === key);
        },
        async removeActivity (workPointIndex, activityIndex, exceptionIndex = null) {
            const confirmation = await Swal.fire({
                title: 'Delete this Activity?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it',
                confirmButtonClass: 'md-button md-success',
                cancelButtonClass: 'md-button md-danger',
            });

            if (confirmation.value === true) {
                try {
                    let activityGuidance;
                    if (exceptionIndex === null) {
                        activityGuidance = this.workPoints[workPointIndex].activities[activityIndex].uuid;
                        console.log(this.workPoints[workPointIndex].activities[activityIndex]);
                    } else {
                        if (typeof this.workPoints[workPointIndex].activities[activityIndex].exceptions[exceptionIndex].uuid !== 'undefined') {
                            activityGuidance = this.workPoints[workPointIndex].activities[activityIndex].exceptions[exceptionIndex].uuid;
                        } else {
                            activityGuidance = this.workPoints[workPointIndex].activities[activityIndex].exceptions[exceptionIndex].id;
                        }
                        console.log(this.workPoints[workPointIndex].activities[activityIndex].exceptions[exceptionIndex]);
                    }
                    if (typeof activityGuidance !== 'undefined') {
                        await this.$store.dispatch('activityGuidances/destroy', activityGuidance);
                        if (exceptionIndex === null) {
                            this.workPoints[workPointIndex].activities.splice(activityIndex, 1);
                        } else {
                            activityGuidance = this.workPoints[workPointIndex].activities[activityIndex].exceptions.splice(exceptionIndex, 1);
                        }
                        await this.$store.dispatch(
                            'alerts/success',
                            'Activity removed successfully.'
                        );
                    } else {
                        await this.$store.dispatch(
                            'alerts/error',
                            'Activity remove fail.'
                        );
                    }
                } catch (e) {
                    if (e.response.data.errors[0]) {
                        await this.$store.dispatch(
                            'alerts/error',
                            e.response.data.errors[0].title
                        );
                    } else {
                        this.notifyException(e);
                    }
                }
            }
        },
        async removeWorkPoint (index) {
            const confirmation = await Swal.fire({
                title: 'Delete this Work Point?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it',
                confirmButtonClass: 'md-button md-success',
                cancelButtonClass: 'md-button md-danger',
            });

            if (confirmation.value === true) {
                try {
                    let guidanceWorkplace = this.workPoints[index].uuid;
                    console.log(this.workPoints[index]);
                    if (typeof guidanceWorkplace !== 'undefined') {
                        await this.$store.dispatch('guidanceWorkplaces/destroy', guidanceWorkplace);
                    }
                    this.workPoints.splice(index, 1);
                    await this.$store.dispatch(
                        'alerts/success',
                        'Work Point removed successfully.'
                    );
                } catch (e) {
                    if (e.response.data.errors[0]) {
                        await this.$store.dispatch(
                            'alerts/error',
                            e.response.data.errors[0].title
                        );
                    } else {
                        this.notifyException(e);
                    }
                }
            }
        },
        async updateActivity (workPointIndex, activityIndex) {
            let activity = this.workPoints[workPointIndex].activities[activityIndex];
            if (typeof activity.activity_id === 'undefined' || activity.activity_id.length < 1) {
                await this.notifyError('Select Activity first');
                return;
            }
            this.workPoints[workPointIndex].activities[activityIndex].saving = true;
            this.savingIds.push('activity' + workPointIndex + '' + activityIndex);

            if (typeof activity.id === 'undefined') {
                delete this.workPoints[workPointIndex].activities[activityIndex].id;
                await this.add(workPointIndex, activityIndex);
            } else {
                console.log('activity to be update ' + activity.id);
                activity.activity_id = activity.activity.id;
                await this.update(workPointIndex, activityIndex);
            }
            this.editableIndex = '';
            this.editableIndex = '';
            this.savingIds.splice(this.savingIds.findIndex(id => id === 'activity' + workPointIndex + '' + activityIndex), 1);
        },
        async toggleProvision (workPointIndex, activityIndex, shift) {
            alert('you make this provision');
            let activity = this.workPoints[workPointIndex].activities[activityIndex];
            if (activity[shift] === 'Provision') {
                this.workPoints[workPointIndex].activities[activityIndex][shift] = 'Open';
            } else {
                this.workPoints[workPointIndex].activities[activityIndex][shift] = 'Provision';
            }
            await this.update(workPointIndex, activityIndex);
            console.log(this.workPoints[workPointIndex].activities[activityIndex][shift]);
            console.log(shift);
            this.editableIndex = '';
            this.editableIndex = '';
        },
        async add (workPointIndex, activityIndex) {
            try {
                let activity = this.workPoints[workPointIndex].activities[activityIndex];
                activity.type = 'activityGuidances';
                await this.$store.dispatch('activityGuidances/add', activity);
                let ag = this.$store.getters['activityGuidances/activityGuidance'];
                activity.id = ag.id;
                this.workPoints[workPointIndex].activities[activityIndex] = activity;
                this.notifySuccess('Activity Guidance added successfully.');
                this.setSuccess(workPointIndex, activityIndex);
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                    this.workPoints[workPointIndex].activities[activityIndex].errors = this.apiValidationErrors;
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
                this.workPoints[workPointIndex].activities[activityIndex].saved = false;
                this.failIds.push('activity' + workPointIndex + '' + activityIndex);
                this.setError(e, workPointIndex, activityIndex);
            }
        },
        async update (workPointIndex, activityIndex) {
            try {
                var activity = this.workPoints[workPointIndex].activities[activityIndex];
                activity.type = 'activityGuidances';
                activity.activity_id = activity.activity.id;
                if (typeof activity.uuid !== 'undefined') {
                    activity.id = activity.uuid;
                }

                await this.$store.dispatch('activityGuidances/update', activity);
                this.setSuccess(workPointIndex, activityIndex);
                await this.$store.dispatch(
                    'alerts/success',
                    'Activity Guidance updated successfully.'
                );
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }

                this.setError(e, workPointIndex, activityIndex);
            }
        },
        async updateGuidanceWorkplace (index) {
            let workPoint = this.workPoints[index];
            console.log('update guidance id ' + workPoint.id);
            try {
                if (typeof workPoint.id !== 'undefined') {
                    console.log('workPoint mwanzo');
                    console.log(workPoint);
                    if (typeof workPoint.uuid !== 'undefined') {
                        workPoint.id = workPoint.uuid;
                    }
                    console.log('workPoint baadae');
                    console.log(workPoint);
                    workPoint.workplace_id = workPoint.workplace.id;
                    delete workPoint.updated_at;
                    workPoint.type = 'guidanceWorkplaces';
                    await this.$store.dispatch('guidanceWorkplaces/update', workPoint);
                    await this.$store.dispatch(
                        'alerts/success',
                        'Work Point updated successfully.'
                    );
                } else {
                    workPoint.type = 'guidanceWorkplaces';
                    workPoint.workplace_id = workPoint.workplace.id;
                    await this.$store.dispatch('guidanceWorkplaces/add', workPoint);
                    var gw = this.$store.getters['guidanceWorkplaces/guidanceWorkplace'];
                    console.log('<<<<<<<');
                    console.log(gw);
                    console.log('>>>>>>>>');
                    workPoint.id = gw.id;
                    this.workPoints[index].id = gw.id;
                    await this.$store.dispatch(
                        'alerts/success',
                        'Work Point Added successfully.'
                    );
                    this.addActivity(index);
                    console.log('mupya');
                    console.log(workPoint);
                }
                // this.workPoints[index] = workPoint
                console.log('mwiso');
                console.log(this.workPoints[index]);
            } catch (e) {
                if (e.response.data.errors[0]) {
                    console.log(e);
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        getAct (myId) {
            console.log(myId);
            const act = this.activities.find(user => {
                if (user.id == myId) {
                    return user;
                }
            });
            if (typeof act !== 'undefined') {
                return act;
            } else {
                return { 'name': 'not Found' };
            }
        },
        async updateWorkPointVessel (value, index) {
            console.log(index);
            let workPoint = this.workPoints[index];
            this.workPoints[index].vessel = value;
            this.workPoints[index].vessel_id = value.id;
            if (typeof workPoint.workplace_id !== 'undefined') {
                await this.updateGuidanceWorkplace(index);
            } else {
                this.$store.dispatch(
                    'alerts/error',
                    'Oops, please select workplace first!'
                );
            }
        },
        async updateWorkPoint (value, index) {
            // value ni selected object, index in id ya select
            // Todo send work point to server for updation
            let checkIdExist = false;
            checkIdExist = this.workPoints.find(work => {
                if (work.workplace.uuid === value.id) {
                    return true;
                }
            });
            if (checkIdExist) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, Workplace already added!'
                );
                return;
            }
            // check if ID exist before proceed
            console.log('check end id is ' + this.workPoints[index].id);
            this.workPoints[index].workplace = value;
            await this.updateGuidanceWorkplace(index);
            console.log('check now id is ' + this.workPoints[index].id);
            this.workPoints[index].activities.forEach((activity) => {
                activity.workplace = value;
                activity.workplace_id = value.id;
            });
        },
        async checkActivity (value, index) {
            // value ni selected object, index in id ya select
            // Todo send work point to server for updation
            let checkIdExist = false;
            let indexes = index.split(':');

            checkIdExist = this.workPoints[indexes[0]].activities.find((activity, localIndex) => {
                let id = activity.activity.id;
                console.log('checking');
                console.log(id);
                console.log(activity);
                if (typeof activity.activity.uuid !== 'undefined') {
                    id = activity.activity.uuid;
                }

                console.log('checking' + id + '= ' + value.id);
                if (localIndex !== indexes[1]) {
                    if (id === value.id && localIndex != indexes[1]) {
                        return true;
                    }
                }
            });
            if (checkIdExist) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, Activity already added!'
                );
                return;
            }
            // check if ID exist before proceed
            this.workPoints[indexes[0]].activities[indexes[1]].activity = value;
            this.workPoints[indexes[0]].activities[indexes[1]].activity_id = value.id;
            await this.updateActivity(indexes[0], indexes[1]);
        },
        setEditable (workPoint) {
            console.log(workPoint.id + ' Clicked');
            this.editableIndex = 'activity' + workPoint.id;
            this.editableWorkPoint = '';
        },
        setEditableWorkPoint (workPoint, variable = 'workPoint') {
            console.log(workPoint.id + 'workPoint');
            this.editableWorkPoint = variable + '' + workPoint.id;
            this.editableIndex = '';
        },
        addException (day, workPointIndex, activityIndex) {
            let checkIdExist = false;
            let act = this.workPoints[workPointIndex].activities[activityIndex];
            checkIdExist = act.exceptions.find(work => {
                if (work.day_type === day) {
                    return true;
                }
            });
            if (!this.exceptionIds.includes(act.id)) {
                this.exceptionIds.push(act.id);
            }
            if (checkIdExist) {
                this.$store.dispatch(
                    'alerts/error',
                    'Oops, Exception already added'
                );
                return;
            }
            let exception = this.getEmptyActivity(workPointIndex, day);
            exception.exception_id = this.workPoints[workPointIndex].activities[activityIndex].id;
            exception.activity_id = this.workPoints[workPointIndex].activities[activityIndex].activity_id;
            exception.activity = this.workPoints[workPointIndex].activities[activityIndex].activity;
            exception.day_type = day;
            exception.type = 'activityGuidances';
            this.workPoints[workPointIndex].activities[activityIndex].exceptions.push(exception);
            this.saveException(workPointIndex, activityIndex, exception);
        },

        async saveException (workPointIndex, activityIndex, exception) {
            try {
                var activity = this.workPoints[workPointIndex].activities[activityIndex];

                await this.$store.dispatch('activityGuidances/add', exception);
                let ex = this.$store.getters['activityGuidances/activityGuidance'];
                exception.id = ex.id;
                this.workPoints[workPointIndex].activities[activityIndex] = activity;
                this.notifySuccess('Activity Guidance added successfully.');
                this.setSuccess(workPointIndex, activityIndex);
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
                this.workPoints[workPointIndex].activities[activityIndex].saved = false;
                this.setError(e, workPointIndex, activityIndex);
            }
        },
        async updateException (workPointIndex, activityIndex, exceptionIndex) {
            try {
                var activity = this.workPoints[workPointIndex].activities[activityIndex].exceptions[exceptionIndex];
                var activityException = this.workPoints[workPointIndex].activities[activityIndex];
                activity.type = 'activityGuidances';
                activity.activity_id = activityException.activity.id;
                if (typeof activity.uuid !== 'undefined') {
                    activity.id = activity.uuid;
                }

                await this.$store.dispatch('activityGuidances/update', activity);
                this.setSuccess(workPointIndex, activityIndex);
                await this.$store.dispatch(
                    'alerts/success',
                    'Activity Guidance updated successfully.'
                );
            } catch (e) {
                console.log(e);
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }

                this.setError(e, workPointIndex, activityIndex);
            }
        },
        toggleExceptions (workPointIndex, activityIndex) {
            var activity = this.workPoints[workPointIndex].activities[activityIndex];
            if (this.exceptionIds.includes(activity.id)) {
                let index = this.exceptionIds.findIndex(tableRow => tableRow === activity.id);
                this.exceptionIds.splice(index, 1);
            } else {
                this.exceptionIds.push(activity.id);
            }
        }
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    .cell-50 {
        min-width: 270px;
        font-weight: 500;
    }

    .cell-10 {
        width: 50px;
        font-weight: 500;
    }


    tbody > tr:last-child .md-button {
        padding: 5px;
        height: 47px;
        min-width: 230px;
        width: 27px;
        line-height: 27px;
        margin: 10px 10px;
    }

    tbody > tr:last-child {
        padding-bottom: 300px
    }

    .your_custom_class >>> .multiselect__option--highlight {
        /*background: #0062cc;*/
        outline: none;
        /*color: #fff;*/
        background-color: #9c27b0 !important;
        box-shadow: 0 12px 20px -10px rgb(156 39 176 / 28%), 0 4px 20px 0px rgb(0 0 0 / 12%), 0 7px 8px -5px rgb(156 39 176 / 20%);
        color: #FFF !important;
        width: fit-content;
    }

    .your_custom_class >>> .multiselect__option {

        width: 900px;
    }

    .outer {
        display: flex;
        align-items: baseline;
    }

    .full {
        flex: 1;
    }
</style>
